import { ThemeOptions } from "@mui/material";
import {
  commonBorderRadius,
  generateDefaultGJTypography,
  generateErrorWarnInfoColors,
  MuiButton,
  MuiChip,
  MuiFilledInput
} from "./util/theme-generator-util";

export const stayBrightFontFamilyRegular = "Montserrat";

export const stayBrightThemeConfig: ThemeOptions = {
  components: {
    MuiChip,
    MuiButton,
    MuiFilledInput,
    MuiAppBar: {
      styleOverrides: {
        root: ({ theme }) => ({
          [theme.breakpoints.up("md")]: {
            backgroundColor: `${theme.palette.primary.main} !important`,
            button: {
              color: `${theme.palette.common.white}!important`,
              span: {
                svg: {
                  color: `${theme.palette.common.white}!important`
                }
              }
            }
          }
        })
      }
    }
  },
  shape: {
    borderRadius: commonBorderRadius
  },
  palette: {
    primary: {
      main: "#001d3f"
    },
    secondary: {
      main: "#00408c"
    },
    ...generateErrorWarnInfoColors(),
    background: {
      default: "#F5F5F5",
      paper: "#FFFFFF"
    },
    text: {
      primary: "#001d3f",
      secondary: "#00408c"
    },
    action: {
      disabledOpacity: 0
    }
  },
  typography: generateDefaultGJTypography(stayBrightFontFamilyRegular)
};
